import { IShopItem, IShopLabel } from '~/src/api/content/shop/getShopItems';

interface IEquipmentProp2 {
    title: string,
    name?: string,
    type?: string,
    value: string,
    asIs?: 0 | 1 | number,
}

/**
 * @param cost стоимость оборудования
 * @param duration длительность рассрочки, если рассрочки нет, то 0
 * параметр duration - передается при создании договора, цена не передается.
 */
export type TPrice = {
    cost: number,
    duration: number,
}

/**
 * @param quantity выбранное количество
 * @param selectedPrice выбранная цена
 */
export interface TProduct {
    id: number,
    category: string,
    categoryTitle: string,
    title: string,
    description: string,
    body: string,
    image: string,
    images: string[],
    labels: IShopLabel[],
    props: IEquipmentProp2[],

    image_width?: number,
    image_height?: number,
    image_webp?: string,

    prices: TPrice[],
    selectedPrice: TPrice,

    quantity: number,
}

/**
 * Подготавливает данные из api shop/items
 * category - может быть родительской или дочерней, если дочерняя берем parentName иначе name
 */
export const transformShopItem = (shopItem: IShopItem): TProduct => {
    // duration = 0 - для полной стомости
    const prices = shopItem.pricesV2.map(price => ({
        cost: price.value,
        duration: price.duration ? price.duration : 0,
    }));

    const [firstPrice] = prices;

    // Если есть родительская категория заполнено parentName иначе name
    const categoryName = shopItem.category?.parentName || shopItem.category?.name;

    return {
        id: shopItem.global_id || shopItem.id, // Для категории product global_id пустой например для 'category/products'
        category: categoryName || '',
        categoryTitle: shopItem.category?.title || '',
        title: shopItem.title,
        description: shopItem.body_full,
        body: shopItem.body,
        props: shopItem.props?.map(({ value = '', asIs = 0, ...prop }) => ({
            ...prop,
            value: Array.isArray(value) ? value.join('') : value, // TODO, требуется замена на shopItems v2 - там только строковые значения для характеристик
            asIs,
        })) || [],
        labels: shopItem.labels || [],

        image: shopItem.image || '',
        images: shopItem.images,
        image_width: shopItem.image_width,
        image_height: shopItem.image_height,
        image_webp: shopItem.image_webp,

        prices,
        selectedPrice: firstPrice,

        quantity: 0,
    };
};
